module.exports = __webpack_public_path__ + "static/media/BigBookMath.04b7141f.svg";